import React from 'react';

const Footer = () => {
  return (
    <footer className='bg-primary py-6 sm:py-12'>
      <div className='container mx-auto'>
        <p className='text-white text-center'>
          Copyright &copy; Flower Clothing 2022. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
